import { getSintegradaServerApi } from "@/services/api";
import { ResumeGrouped } from "@/services/esus/attendanceService";

export type ExamItemDashboardParams = {
	uf: string;
	ibgeCode: string;
	startDate: string;
	endDate: string;
	cnes?: string;
	minAge?: number;
	maxAge?: number;
	professionalId?: number;
};

export type RealizedExams = {
	description: string;
	averageTimeInSeconds: number;
};

export type Procedure = {
	name: string;
	total: number;
};

export type MedicationAdministration = {
	name: string;
	total: number;
};

export type VitalSign = {
	name: string;
	total: number;
};

export type ExamItemDashboardData = {
	aggregatedRequestedExamBySigtapCode?: ResumeGrouped<string, object>[];
	aggregatedRequestedExamByHealthUnit?: ResumeGrouped<string, object>[];
	aggregatedRequestedExamByProfessional?: ResumeGrouped<string, object>[];
	totalRequestedLaboratoryExams?: number;
	totalRequestedRadiography?: number;
	aggregatedRealizedExamBySigtapCode?: ResumeGrouped<RealizedExams, object>[];
	aggregatedRealizedExamByHealthUnit?: ResumeGrouped<string, object>[];
	aggregatedRealizedExamByProfessional?: ResumeGrouped<string, object>[];
	totalRealizedLaboratoryExams?: number;
	totalRealizedRadiography?: number;
	aggregatedCancelledExamBySigtapCode?: ResumeGrouped<string, object>[];
	aggregatedCancelledExamByHealthUnit?: ResumeGrouped<string, object>[];
	aggregatedCancelledExamByProfessional?: ResumeGrouped<string, object>[];
	totalCancelledLaboratoryExams?: number;
	totalCancelledRadiography?: number;
	aggregatedByGeneralProcedure?: ResumeGrouped<
		string,
		ResumeGrouped<"Solicitado" | "Realizado" | "Cancelado", object>
	>[];
	aggregatedBymedicinesByAdministrationRoute?: ResumeGrouped<
		string,
		ResumeGrouped<string, object>
	>[];
	totalRequestedExams?: number;
	totalRealizedExams?: number;
	totalCancelledExams?: number;
	totalAverageRealizedTimeInSeconds?: number;
	totalWeightedAverageOfExamsCompletedInSeconds: number;
	averageRealizedTimeInSecondsBySigtapCode?: ResumeGrouped<string, object>[];
	aggregatedByPeriodAndStatusType?: ResumeGrouped<
		string,
		ResumeGrouped<"Solicitado" | "Realizado" | "Cancelado", object>
	>[];
	totalExamsRequested?: {
		interno: number;
		eletivo: number;
	};
	totalExamsCompleted?: {
		interno: number;
		eletivo: number;
	};
	totalExamsCancelled?: {
		interno: number;
		eletivo: number;
	};
	totalLaboratoryExams?: {
		requested: number;
		completed: number;
		cancelled: number;
	};
	totalRadiographyExams?: {
		requested: number;
		completed: number;
		cancelled: number;
	};
	totalProceduresByProcedure?: Procedure[];
	totalMedicationAdministration?: MedicationAdministration[];
	totalVitalSigns?: VitalSign[];
};

export async function getExamItemDashboard({ uf, ibgeCode, ...params }: ExamItemDashboardParams) {
	const response = await getSintegradaServerApi().get<ExamItemDashboardData>(
		`/attendance/exams-dashboard`,
		{ ibgeCode, ...params }
	);
	return response.data;
}
